import React, { useState } from "react";
import { FloatButton } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import Modal from "./Modal";
import AnimatedOpenButton from "./AnimatedOpenButton";
import { PiEngineDuotone } from "react-icons/pi";
import { BiSolidCarMechanic } from "react-icons/bi";
import { BsFillCalendar2DateFill } from "react-icons/bs";
import "./Main.css";
import AboutUs from "./AboutUs";
import AppointmentForm from "./AppointmentForm";
import VisionMissionCard from "./VisionMissionCard";

const Main: React.FC = () => {
  const [activeComponent, setActiveComponent] = useState<string | null>(null);
  const [isExpanded, setIsExpanded] = useState(false);

  const openComponent = (component: string) => {
    setActiveComponent(component);
    setIsExpanded(false); // Close the expanded state when a component is selected
  };

  const closeComponent = () => {
    setActiveComponent(null);
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div id="main">
      <div className={`float-button-group ${isExpanded ? "expanded" : ""}`}>
        <AnimatedOpenButton handleClick={toggleExpand} mainButton={true}>
          <BiSolidCarMechanic />
        </AnimatedOpenButton>
        {isExpanded && (
          <>
            <AnimatedOpenButton handleClick={() => openComponent("appointment")}>
              <BsFillCalendar2DateFill />
            </AnimatedOpenButton>
            <AnimatedOpenButton handleClick={() => openComponent("about")}>
              <PiEngineDuotone />
            </AnimatedOpenButton>
            <AnimatedOpenButton handleClick={() => openComponent("vision")}>
              <InfoCircleOutlined />
            </AnimatedOpenButton>
          </>
        )}
      </div>

      {activeComponent && (
        <Modal isOpen={!!activeComponent} handleClose={closeComponent}>
          {activeComponent === "about" && <AboutUs />}
          {activeComponent === "vision" && (
            <div className="vision-mision-container">
              <VisionMissionCard
                title="Our vision"
                content="Be leaders in innovation and quality."
                hueA={340}
                hueB={10}
              />
              <VisionMissionCard
                title="Our mission"
                content="Offer exceptional products with a total commitment to customer satisfaction."
                hueA={20}
                hueB={40}
              />
            </div>
          )}
          {activeComponent === "appointment" && <AppointmentForm />}
        </Modal>
      )}
    </div>
  );
};

export default Main;
